var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllergies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Allergies",
    clipPath: "url(#clip0_1232_23542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_diamond_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94249 1.87085L14.1278 7.05685C14.3778 7.30689 14.5182 7.64597 14.5182 7.99952C14.5182 8.35307 14.3778 8.69215 14.1278 8.94218L8.94249 14.1275C8.69246 14.3775 8.35338 14.5179 7.99983 14.5179C7.64628 14.5179 7.3072 14.3775 7.05716 14.1275L1.87183 8.94218C1.62187 8.69215 1.48145 8.35307 1.48145 7.99952C1.48145 7.64597 1.62187 7.30689 1.87183 7.05685L7.05716 1.87085C7.3072 1.62089 7.64628 1.48047 7.99983 1.48047C8.35338 1.48047 8.69246 1.62089 8.94249 1.87085ZM8.00116 9.99952C7.83113 9.99937 7.66746 10.0642 7.54364 10.1807C7.41983 10.2973 7.34522 10.4567 7.33509 10.6264C7.32495 10.7962 7.38006 10.9634 7.48912 11.0938C7.59819 11.2243 7.75298 11.3081 7.92183 11.3282L8.00183 11.3329C8.17864 11.3329 8.34821 11.2626 8.47323 11.1376C8.59826 11.0126 8.66849 10.843 8.66849 10.6662C8.66849 10.4894 8.59826 10.3198 8.47323 10.1948C8.34821 10.0698 8.17864 9.99952 8.00183 9.99952H8.00116ZM7.99983 5.33285C7.45249 5.33285 7.02183 5.78752 7.03983 6.32285L7.04649 6.41285L7.33849 8.74885C7.35775 8.90363 7.43066 9.04675 7.54454 9.15333C7.65842 9.2599 7.80606 9.32317 7.96177 9.33213C8.11748 9.34109 8.2714 9.29517 8.39676 9.20236C8.52211 9.10955 8.61095 8.97573 8.64783 8.82418L8.66116 8.74885L8.95316 6.41285C8.97008 6.27767 8.95806 6.14043 8.91789 6.01024C8.87771 5.88006 8.81031 5.75991 8.72015 5.65777C8.62999 5.55563 8.51913 5.47384 8.39494 5.41782C8.27075 5.3618 8.13607 5.33284 7.99983 5.33285Z",
    fill: "#ED9A5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergies);
export default __webpack_public_path__ + "static/media/allergies.7d73612be30bfa66f61f90cd0ecce1be.svg";
export { ForwardRef as ReactComponent };